// 메모 레코드 판별용 헬퍼 — SearchTablePage.openItem 이 정적 import 하므로
// 기존 jest 모듈 로드에 부담이 없도록 의존성 zero 로 유지할 것

// 목록 행에는 템플릿 id 가 없고 템플릿 icon 만 내려온다 (backend api_list_resource).
// 기본 Memo 템플릿의 icon(file-text)으로 판별 — 커스텀 템플릿이 같은 아이콘을 쓰면
// 오탐할 수 있는 스파이크 수준 판별자 (정식화 시 목록 응답에 template id 추가 검토)
export const MEMO_TEMPLATE_ICON = 'file-text'

export const isMemoRecord = (record) => {
  // 즐겨찾기 등 일부 목록은 record.resource 로 감싸서 내려온다
  const resource = record?.resource || record
  // 서버가 계산한 권위 필드(is_memo) 우선 — 아이콘 추측의 오탐(파비콘/동일 아이콘 커스텀
  // 템플릿)을 제거한다. 목록 API 가 is_memo 를 내려주면 이 경로만 탄다.
  if (typeof resource?.is_memo === 'boolean') return resource.is_memo
  // 폴백: is_memo 없는 구버전 응답(배포 과도기·구 캐시) — 기존 아이콘 추측 유지.
  // 목록 행은 icon 을 template.icon 아래에 담는다 (RecordIcon·RecordDetail 과 동일 접근자:
  // record.icon || record.template.icon || record.template_icon)
  const icon = resource?.icon || resource?.template?.icon || resource?.template_icon
  return icon === MEMO_TEMPLATE_ICON
}

// 사용자 노출 문구의 레코드 종류 단어("메모"/"メモ"/"Memo") i18n 키.
// 삭제·편집·공유 등 공용 흐름의 {{service}} 자리에 패스워드 브랜딩(SERVICE_NAME) 대신 쓴다.
export const MEMO_RECORD_WORD_KEY = 'record.badge.memo'

// {{service}} 인터폴레이션에 넣을 i18n 키 선택 — 메모 레코드면 "메모", 아니면 브랜딩 서비스명.
// brandServiceKey(보통 SERVICE_NAME)는 호출부가 전달한다 — 이 모듈은 의존성 zero 유지
// (service.js 는 conf/env 를 끌고 와 jest 모듈 로드가 무거워짐).
// featureFlags 게이팅은 하지 않는다: 문구는 기능 진입점이 아니라 "레코드가 실제로 메모인가"의
// 문제라, 플래그와 무관하게 메모 레코드에는 메모 단어가 맞다.
export const getRecordServiceKey = (record, brandServiceKey) =>
  isMemoRecord(record) ? MEMO_RECORD_WORD_KEY : brandServiceKey

// 템플릿 목록(ResourceTemplateService.getAll)의 항목이 전역 memo 템플릿인지 판별.
// name 은 로케일별 번역 title 로 내려올 수 있어(resource_template.get_dict) locale-proof 한
// readonly(전역 기본 템플릿) + icon 조합으로 식별한다 (CreateMemoModal.handleSaveCreate 와 동일 키).
// 패스워드 생성 패널(RecordEdit fieldManager)의 템플릿 셀렉트에서 메모 템플릿을 제외하는 데 사용.
export const isMemoTemplate = (template) => {
  return Boolean(template?.readonly) && template?.icon === MEMO_TEMPLATE_ICON
}
